import { ROUTE_URLS } from 'router/routes'

import { localeCommonKeysType } from 'shared/locale/en-US'
import { UpgamingSportPages } from 'shared/models/Upgaming'

import sport1 from '../img/sport1.png'
import sport2 from '../img/sport2.png'
import sport3 from '../img/sport3.png'
import { ChoiceOfSport } from '../types'

interface IChoiceOfSportTypes {
  link: string
  mobileLink?: string
  text: localeCommonKeysType
  icon?: string
}

export const choiceofSport: Record<ChoiceOfSport, IChoiceOfSportTypes[]> = {
  sport: [
    {
      link: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
      text: 'digitain',
      icon: sport1,
    },
    {
      link: ROUTE_URLS.BETBY_SPORT(),
      text: 'betby',
      icon: sport2,
    },
    {
      link: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME),
      text: 'upgaming',
      icon: sport3,
    },
  ],
  liveSport: [
    {
      link: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Live'),
      text: 'digitain',
      icon: sport1,
    },
    {
      link: ROUTE_URLS.BETBY_SPORT('live'),
      text: 'betby',
      icon: sport2,
    },
    {
      link: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.LIVE),
      text: 'upgaming',
      icon: sport3,
    },
  ],
  betHistory: [
    {
      link: ROUTE_URLS.DIGITAIN_SPORT_PAGE('BetsHistory'),
      text: 'digitain',
      icon: sport1,
    },
    {
      link: ROUTE_URLS.BETBY_SPORT('bets'),
      text: 'betby',
      icon: sport2,
    },
    {
      link: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.BET_HISTORY),
      text: 'upgaming',
      icon: sport3,
    },
  ],
}
